import { COLORS } from '@/styles/colors';
import { poppinsSemiBoldFont } from '@/styles/typography';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 24px;
  border-radius: 16px;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.grey[400]};
  margin-bottom: 16px;
  cursor: pointer;

  &:hover {
    background-color: ${COLORS.grey[150]};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CardInfo = styled.div<{ noRatio?: boolean }>`
  display: flex;
  gap: 24px;
  flex: 2;
  min-width: 0;

  ${({ noRatio }) =>
    noRatio &&
    `
    flex: 0 1 auto;
  `}
`;

export const CardMain = styled.div`
  flex: 2;
  min-width: 0;
`;

export const CardActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: center;
  margin-left: auto;
`;

export const BankName = styled.div<{ closed?: boolean }>`
  display: block;
  width: 54px;
  ${poppinsSemiBoldFont};
  align-self: center;
  text-align: center;
  padding: 16px;
  color: ${COLORS.green[500]};
  background-color: ${COLORS.mint[200]};
  border-radius: 8px;

  ${({ closed }) =>
    closed &&
    `
    color: ${COLORS.grey[700]};
    background-color: ${COLORS.grey[300]};
  `}
`;
